function LetterHead () {
    return(
        <div className="letter-head d-none d-print-block my-4">
            <img src="/sgi_logo_letterhead.svg" alt="SGI Logo" width="128" height="30" />
            <hr />
        </div>
    );
}

export default LetterHead;